import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestUpdateDeliveryFee } from "./updateDeliveryFee.request";

const useUpdateDeliveryFee = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestUpdateDeliveryFee,
    ...options
  });
};

export default useUpdateDeliveryFee;
